import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const token = localStorage.getItem('AccessToken');
    if (token) {
      this.router.navigate(['/new-deposit'], {
        replaceUrl: true,
      });
      return false;
    }
    return true;
  }
}
